import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios";
import "./HomeProductsSlider.css";
import defaultImg from "../Assets/Vangal Ghee.png"; 

export default function ProductsSlider() {
  const [productSlides, setProductSlides] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await axios.get(
          "https://vangal-backend.onrender.com/api/products"
        );
        const slides = res.data.map((p) => ({
          id: p.id,
          img: p.img,
          title: p.title,
        }));
        setProductSlides(slides);
      } catch (err) {
        console.error("Failed to fetch products:", err);
      }
    };

    fetchProducts();
  }, []);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 900,
    slidesToShow: 1, // always show only 1 image
    slidesToScroll: 1,
    autoplaySpeed: 2500,
  };

  return (
    <section className="vangal-products-wrapper">
      <div className="vangal-products-container">
        <div className="vangal-products-left anim anim-top">
          <Slider {...settings}>
            {productSlides.length > 0
              ? productSlides.map((item) => (
                  <div key={item.id} className="vangal-products-slide">
                    <img
                      src={item.img}
                      alt={item.title}
                      className="vangal-products-image"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = defaultImg; // fallback
                      }}
                    />
                  </div>
                ))
              : [1].map((_, idx) => (
                  <div key={idx} className="vangal-products-slide">
                    <img
                      src={defaultImg}
                      alt="Default Product"
                      className="vangal-products-image"
                    />
                  </div>
                ))}
          </Slider>
        </div>

        <div className="vangal-products-right anim anim-bottom">
          <h2 className="vangal-products-title1">
            The Vangal Farms <br /> Selection
          </h2>
          <p className="vangal-products-text">
            Discover our certified range of milk, curd, buttermilk, paneer,
            butter, ghee, honey – with many more wholesome products coming soon.
          </p>
          <a className="vangal-products-viewall" href="/products">
            View All Products <span>➜</span>
          </a>
        </div>
      </div>
    </section>
  );
}
